import { memo } from 'react';
import { SignatureComponent } from '@library';

interface StoryblokSignatureComponentProps {
    onChange: (dataURL: string) => void;
    placeholder?: string;
}

const StoryblokSignatureComponent = ({
    onChange,
    placeholder,
}: StoryblokSignatureComponentProps) => {
    return <SignatureComponent placeholder={placeholder} onChange={onChange} />;
};

export default memo(StoryblokSignatureComponent);
